import { useSearchParams } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { LocalImportWizard } from '@/components/imports/LocalImportWizard'
import { appCopyRequest } from '@/services/appCopy'
export function LocalImportsPage() {
  const { session } = useAuth(); const [params] = useSearchParams(); const type = params.get('type');
  const kind = type === 'products' || type === 'customers' ? type : undefined;
  return <LocalImportWizard key={`${session?.businessId}:${kind}`} appName="CRM" businessKey={session?.businessId ?? ''} request={appCopyRequest} importKind={kind} />
}
